<template lang="html">
  <div class="row general-terms">
    <Header />
    <div class="col-md-1"></div>
    <div class="col-md-10">
      <div class="text-center">
        <h3>{{translation.generalTerms.title}}</h3>
        <router-link :to="{name:'home', params:{ lang: lang}}">{{translation.generalTerms.link}}</router-link>
      </div>
      <div>
        <h4>{{translation.generalTerms.h1}}</h4>
        <p><span>{{translation.generalTerms.p1}}</span><router-link :to="{name:'home', params:{ lang: lang}}">{{translation.generalTerms.link}}</router-link><span>{{translation.generalTerms.p2}}</span></p>
        <p><span>{{translation.generalTerms.p3}}</span><router-link :to="{name:'home', params:{ lang: lang}}">{{translation.generalTerms.link}}</router-link><span>{{translation.generalTerms.p4}}</span></p>
        <p>{{translation.generalTerms.p5}}</p>
        <p>{{translation.generalTerms.p6}}</p>
        <p>{{translation.generalTerms.p7}}</p>
        <p>{{translation.generalTerms.p8}}</p>
        <p>{{translation.generalTerms.p9}}</p>
      </div>
      <div>
        <h4>{{translation.generalTerms.h2}}</h4>
        <p>{{translation.generalTerms.p10}}</p>
        <p>{{translation.generalTerms.p11}}</p>
        <p>{{translation.generalTerms.p12}}</p>
        <p>{{translation.generalTerms.p13}}</p>
        <p>{{translation.generalTerms.p14}}</p>
        <p>{{translation.generalTerms.p15}}</p>
        <p>{{translation.generalTerms.p16}}</p>
        <p>{{translation.generalTerms.p17}}</p>
        <p>{{translation.generalTerms.p18}}</p>
        <p>{{translation.generalTerms.p19}}</p>
      </div>
      <div>
        <h4>{{translation.generalTerms.h3}}</h4>
        <p>{{translation.generalTerms.p20}}</p>
        <p>{{translation.generalTerms.p21}}</p>
        <p>{{translation.generalTerms.p22}}</p>
        <p>{{translation.generalTerms.p23}}</p>
        <p>{{translation.generalTerms.p24}}</p>
        <p>{{translation.generalTerms.p25}}</p>
        <p>{{translation.generalTerms.p26}}</p>
        <p>{{translation.generalTerms.p27}}</p>
        <p>{{translation.generalTerms.p28}}</p>
        <p>{{translation.generalTerms.p29}}</p>
        <p>{{translation.generalTerms.p30}}</p>
        <p>{{translation.generalTerms.p31}}</p>
        <p>{{translation.generalTerms.p32}}</p>
      </div>
      <div>
        <h4>{{translation.generalTerms.h4}}</h4>
        <p>{{translation.generalTerms.p33}}</p>
        <p>{{translation.generalTerms.p34}}</p>
        <p>{{translation.generalTerms.p35}}</p>
        <p>{{translation.generalTerms.p36}}</p>
        <p>{{translation.generalTerms.p37}}</p>
      </div>
      <div>
        <h4>{{translation.generalTerms.h5}}</h4>
        <p>{{translation.generalTerms.p38}}</p>
        <p>{{translation.generalTerms.p39}}</p>
        <p>{{translation.generalTerms.p40}}</p>
        <p>{{translation.generalTerms.p41}}</p>
        <p>{{translation.generalTerms.p42}}</p>
        <p>{{translation.generalTerms.p43}}</p>
        <p>{{translation.generalTerms.p44}}</p>
        <p>{{translation.generalTerms.p45}}</p>
        <p>{{translation.generalTerms.p46}}</p>
        <p>{{translation.generalTerms.p47}}</p>
        <p>{{translation.generalTerms.p48}}</p>
        <p>{{translation.generalTerms.p49}}</p>
        <p>{{translation.generalTerms.p50}}</p>
        <p>{{translation.generalTerms.p51}}</p>
        <p>{{translation.generalTerms.p52}}</p>
        <p>{{translation.generalTerms.p53}}</p>
        <p>{{translation.generalTerms.p54}}</p>
        <p>{{translation.generalTerms.p55}}</p>
        <p>{{translation.generalTerms.p56}}</p>
        <p>{{translation.generalTerms.p57}}</p>
        <p>{{translation.generalTerms.p58}}</p>
        <p>{{translation.generalTerms.p59}}</p>
        <p>{{translation.generalTerms.p60}}</p>
        <p>{{translation.generalTerms.p61}}</p>
      </div>
      <div>
        <h4>{{translation.generalTerms.h7}}</h4>
        <p>{{translation.generalTerms.p69}}</p>
      </div>
      <div>
        <h4>{{translation.generalTerms.h8}}</h4>
        <p>{{translation.generalTerms.p70}}</p>
        <p>{{translation.generalTerms.p71}}</p>
        <p>{{translation.generalTerms.p72}}</p>
      </div>
      <div>
        <h4>{{translation.generalTerms.h9}}</h4>
        <p>{{translation.generalTerms.p73}}</p>
        <p>{{translation.generalTerms.p74}}</p>
        <p>{{translation.generalTerms.p75}}</p>
      </div>
      <div>
        <br/>
        <p>{{translation.generalTerms.p76}}</p>
        <br/>
      </div>
      <div>
        <p><b>{{translation.generalTerms.p77}}</b></p>
      </div>
    </div>
    <div class="col-md-1"></div>
  </div>
</template>

<script>
import Header from '../components/Header.vue';
export default {
  data(){
    return {
      translation: null,
      lang: window.lang
    }
  },
  created(){
    this.$bus.$on('language', () => {
      this.translation = window.message;
    });
    this.translation = window.message;
  },
  components: {
    Header
  }
}
</script>

<style lang="css" scoped>
#app .general-terms{
  background: #fff;
  margin-bottom: 3em;
}
#app .general-terms h3,#app .general-terms h4{
  text-align: center;
  margin-top: 2em;
}
#app .general-terms {
  text-align: left;
}
</style>
